import marketingUrls from "shared/marketing-website/constants/urls"

// constants based on app/static/frontend/subfeatures/RegionSelectionPage/constants.js

export const MAJOR_REGION_DESCRIPTIONS = {
    [DjangIO.app.models.SupportedRegion.federal.value]: "The US Federal Government",
    [DjangIO.app.models.SupportedRegion.states.value]: "All state governments in the US available to you",
    [DjangIO.app.models.SupportedRegion.local.value]: "Municipal and county governments available to you",
    [DjangIO.app.models.SupportedRegion.eu.value]: "",
    [DjangIO.app.models.SupportedRegion.all_regions.value]: "Every region in the US available to you",
    [DjangIO.app.models.SupportedRegion.states_and_local.value]:
        "State, municipal, and county governments in the US available to you",
    [DjangIO.app.models.SupportedRegion.international.value]: "Every region that is not in the US available to you",
    [DjangIO.app.models.SupportedRegion.user_global.value]: "Every region available to you",
    [DjangIO.app.models.SupportedRegion.eu_member_states.value]: "Only Countries in the EU, not EU governing bodies",
}

export const MAJOR_REGION_SET = new Set([
    DjangIO.app.models.SupportedRegion.all_regions.value,
    DjangIO.app.models.SupportedRegion.federal.value,
    DjangIO.app.models.SupportedRegion.states_and_local.value,
    DjangIO.app.models.SupportedRegion.states.value,
    DjangIO.app.models.SupportedRegion.local.value,
    DjangIO.app.models.SupportedRegion.eu.value,
    DjangIO.app.models.SupportedRegion.user_global.value,
    DjangIO.app.models.SupportedRegion.international.value,
    DjangIO.app.models.SupportedRegion.eu_member_states.value,
])

export const PRODUCT_PAGE_PATHS = {
    [DjangIO.app.models.SupportedRegion.federal.value]: marketingUrls.federalProduct,
    [DjangIO.app.models.SupportedRegion.states.value]: marketingUrls.stateProduct,
    [DjangIO.app.models.SupportedRegion.local.value]: marketingUrls.localProduct,
    [DjangIO.app.models.SupportedRegion.eu.value]: marketingUrls.euProduct,
    [DjangIO.app.models.SupportedRegion.all_regions.value]: marketingUrls.federalProduct,
    [DjangIO.app.models.SupportedRegion.states_and_local.value]: marketingUrls.stateProduct,
    [DjangIO.app.models.SupportedRegion.international.value]: marketingUrls.internationalProduct,
}

// based on app/static/frontend/subfeatures/RegionSelectionPage/helperFunctions.jsx > getRegionAbbrevValueMapping
export const REGION_ABBREV_VALUE_MAPPING = DjangIO.app.models.SupportedRegion.items().reduce(
    (mapping, region) => ({
        ...mapping,
        [region.abbrev]: region.value,
    }),
    {},
)

export const CUSTOM_REGIONS_QUERY_INVALIDATE_EVENT = "invalidate-custom-regions-query"
export const CUSTOM_REGIONS_QUERY_KEY = "customRegions"
export const RECENT_REGIONS_QUERY_KEY = "recentRegions"
